import React, { useState, useEffect } from "react";
import { useAppContext } from "../libs/contextLib";
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./ThankYou.css";

export default function ThankYou() {
    const { isAuthenticated, business } = useAppContext();
    const [isLoading, setIsLoading] = useState(true);
    const [copied, setCopied] = useState(false);

    const shareUrl = 'sertify.io';

    const shareFB = (e) => {
        e.preventDefault();
        e.stopPropagation();
        window.FB.ui({
            method: 'share',
            href: shareUrl,
        }, function(response){});
    };

    useEffect(() => {
        async function onLoad() {
            if (!isAuthenticated) {
                return;
            }
            setIsLoading(false);
        }
  
        onLoad();
    }, [isAuthenticated, business]);

    function getMailToContent() {
        var content = "mailto:?subject=Check out Sertify!&body=Hi,%0D%0A%0D%0AI'm excited to tell you that I'm now part of Sertify. This community helps connect consumers to small businesses.%0D%0A%0D%0AThought you might like to check it out: https://www.sertify.io/small-businesses%0D%0A%0D%0ACheers,%0D%0A" + business.ownerFirstName;
        return content;
    }

    function onCopy() {
        setCopied(true);
    };

    return (
        <div className="content">
            {isAuthenticated && !isLoading && (
                <div className="thankyou">
                    <div className="contentHeader">
                        <h2>Done!</h2>
                    </div>
                    <div className="contentBody"> 
                        <div className="row-bottom-20 center-text"> 
                            Please let us know if you have any questions or suggestions - <a href="mailto:support@sertify.io">contact us</a>!
                        </div>
                        <div className="center-text">
                            Share the word about Sertify. Together, we can make your community Powered by Small.
                        </div>
                    </div>
                    <div className="contentBody center-text">
                        <Row>
                            <Col>
                                <div className="facebook" rel="noopener noreferrer" onClick={shareFB}>
                                    <FontAwesomeIcon icon={['fab', 'facebook']} size="3x"></FontAwesomeIcon>
                                </div>
                            </Col>
                            <Col>                       
                                <a href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(shareUrl)}&text=I+have+joined+@SertifySmall+!+It+helps+consumers+find+small+biz+like+mine.+Let's+make+our+community+%23PoweredBySmall+%23ShopLocal+Check+out`} target="_blank" rel="noopener noreferrer">
                                    <FontAwesomeIcon icon={['fab', 'twitter']} size="3x"></FontAwesomeIcon>
                                </a> 
                            </Col>
                            {/* <Col>
                                <a href="https://www.instagram.com" target="_blank" rel="noopener noreferrer">
                                    <FontAwesomeIcon icon={['fab', 'instagram']} size="3x"></FontAwesomeIcon>
                                </a>
                            </Col> */}
                            
                            <Col>
                                <a href={getMailToContent()} target="_blank" rel="noopener noreferrer">
                                    <FontAwesomeIcon icon="envelope" size="3x"></FontAwesomeIcon>
                                </a>
                            </Col>
                        </Row>
                    </div>
                    <div className="contentBody">
                        <div className="text-linkBtn center-text">
                            <label>{copied ? "Copied" : "Click to Copy"}</label>
                            <CopyToClipboard
                                onCopy={onCopy}
                                text={"https://www.sertify.io/small-businesses"}>
                                <div className="pointer linkBtn-text">https://www.sertify.io/small-businesses</div>
                            </CopyToClipboard>
                        </div>
                    </div>
                    { /*
                    <div className="pageButtons-multiple  row-top-10">
                        <LinkContainer key="nextHome" to="/home">
                            <Button variant="primary">Home</Button>
                        </LinkContainer>
                    </div>
                    */}
                </div>
            )}
        </div>
    );
}